export function isIE(): boolean {
  return (window.document as any).documentMode !== undefined
}

export function isEdge(): boolean {
  const ua: string = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('edge') >= 0
}
